module.exports = __webpack_public_path__ + "static/img/IMG_20240810_161716-ANIMATION.07e7bb75.gif";